import type { FunctionComponent } from "react";

import type { ITrafficShareBarProps } from "../../../styled components/StyledTrafficShare/src/StyledTrafficShare";
import { TrafficShareTooltip } from "../../tooltips/src/TrafficShareTooltip/TrafficShareTooltip";

import { TrafficShare } from "./TrafficShare";

export interface ITrafficShareProps {
    data: ITrafficShareBarProps[];
    title: string;
    barGap?: number;
    trafficShareHeight?: number;
    minWidthToShowData?: number;
    minWidthToShowDataMiddle?: number;
    trafficShareClassName?: string;
    subTitles?: string[];
}

export const TrafficShareWithTooltip: FunctionComponent<ITrafficShareProps> = ({
    data,
    title,
    barGap,
    trafficShareHeight,
    minWidthToShowData,
    minWidthToShowDataMiddle,
    trafficShareClassName,
    subTitles,
}) => {
    const hasData = data && data.some((item) => Number(item.width) > 0);
    return hasData ? (
        <TrafficShareTooltip
            trafficShareProps={data}
            title={title}
            subTitles={subTitles}
        >
            <TrafficShare
                data={data}
                barGap={barGap}
                height={trafficShareHeight}
                minWidthToShowData={minWidthToShowData}
                minWidthToShowDataMiddle={minWidthToShowDataMiddle}
                className={trafficShareClassName}
            />
        </TrafficShareTooltip>
    ) : null;
};
